<template>
    <div point question :id="`question-${questionData.number}`" @keyup.enter="submitQuestion">
        <questionheader :questionData="questionData" />
        <div data-question-main>
            <div
                v-for="(answer, index) in questionData.answers"
                :key="`answer-${index}`"
                data-answer
            >
                <div data-answer-container>
                    <questioninput
                        :answerData="answer"
                        :questionData="questionData"
                        :disabled="!get.editingAllowed(questionData)"
                    />
                    <answerdescription
                        v-if="answer.description !== `` "
                        :answerData="answer"
                        :questionData="questionData"
                    />
                </div>
            </div>
            <div data-total aria-live="assertive">
                <p data-text-total>{{$store.getters.textResource(`rs_total`)}}</p>
                <p
                    data-remaining
                >{{remainingPoints}} {{$store.getters.textResource(`rs_remaining`)}}</p>
                <p>/{{questionData.points}}</p>
            </div>
        </div>
        <questionfooter :questionData="questionData" />
        <!-- The component that gives the user hints on how the validation goes -->
        <validationpopup :questionValidation="questionValidation" :customValidation="customValidation" />
    </div>
</template>

<script>
import mixins from "@/global/mixins";

export default {
    name: `pointdistribution-question`,
    mixins: [mixins.defaultQuestion],
    computed: {
        answersGiven() {
            return this.questionData.answers.filter((answer) => answer.openField !== ``).length;
        },
        remainingPoints: function () {
            let pointsGiven = 0;
            let points = this.restrictions.requiredPoints;
            let decimals = this.questionData.answers[0].validation["numberScale"];

            this.questionData.answers.forEach((answer) => {
                if (answer.openField === ``) return;

                pointsGiven += parseFloat(answer.openField.replace(/,/, "."));
            });

            let remainingPoints = points - pointsGiven;
            if (remainingPoints !== 0 && decimals != -1) {
                return remainingPoints.toFixed(decimals);
            } else {
                return remainingPoints;
            }
        },
        customValidation(){
            return [{ isValid: this.remainingPoints === 0, validationType: `requiredPoints`, value: this.restrictions.requiredPoints }];
        }
    }
};
</script>

<style lang="scss" scoped>
[data-answer] {
    align-items: flex-start;
    flex-direction: column;
}

[data-answer-container] {
    display: flex;
    align-items: center;
    width: 100%;
}
[data-total] {
    padding-left: 5px;

    [data-text-total] {
        display: block;
    }
    [data-remaining] {
        color: var(--primary-color);
    }
}
</style>